import { Injectable } from '@angular/core';
import { CommonService } from "@services/utils/common.service";
import { PvRolUser } from "@models/rol-user";
import { environment } from "../../../environments/environment";
import { ApiHelperService } from "@services/apihelper/api-helper.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RolUserService extends CommonService<PvRolUser, string> {

  protected API_URL : string = `${environment.URL_API}/pvroluser`;

  constructor(http: ApiHelperService) {
    super(http);
  }

  getRolesByUser(userMail: string): Observable<PvRolUser[]> {
    return this.http.get<PvRolUser[]>(`${this.API_URL}/user/${userMail}/roles`);
  }

  getUsersByRole(rolId: string): Observable<PvRolUser[]> {
    return this.http.get<PvRolUser[]>(`${this.API_URL}/role/${rolId}/users`);
  }

  addUserToRole(userMail: string, rolId: string): Observable<PvRolUser> {
    return this.http.put<PvRolUser>(
      `${this.API_URL}/user/${userMail}/role/${rolId}`, {} as PvRolUser);
  }

  removeUserFromRole(userMail: string, rolId: string): Observable<PvRolUser> {
    return this.http.delete<PvRolUser>(`${this.API_URL}/user/${userMail}/role/${rolId}`);
  }
}
